<app-sign-in-ui
  (submitClick)="submit($event)"
></app-sign-in-ui>
